/* eslint-disable react-hooks/exhaustive-deps */
// react
import { useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router-dom"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcSelector from "@grapecity/wijmo.grid.selector"

// other
import queryString from "query-string"
import Decimal from "decimal.js"
import dayjs from "dayjs"
// Kairos
import { AppDispatch } from "../../../.."
import AlertComponent from "../../../../components/AlertComponent"
import MonthInput from "../../../../components/InputWrapper/MonthInput"

// import ConfirmModal from "../../components/ConfirmModal"
import DisplaySearchConditionLabel from "../../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../../components/Spinner"
import CONST from "../../../../constant"
import {
  clearAlert,
  setWarningAlerts,
  setAlerts,
} from "../../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../../globalStore/progressStore"
import { 請求_支払管理メニューコード } from "../../../../constant/menuCode"
import { TApiResponse } from "../../../../service/TApiResponse"

import { RootState } from "../../../../globalStore/rootreducer"
import MakePaymentService from "../../../../service/billing/payment/makePaymentService"
import {
  TPaymentMakeListGetRes,
  TPaymentMakeListGetReq,
  TPaymentSiharaiSimePostReq,
  TPaymentPrintSiharaiMeisaisyoReq,
  TPaymentSiharaiSimeCheckListGetRes,
  TPaymentSiharaiMeisaisyoCheckListGetRes,
} from "../../../../service/billing/payment/TPayment"
import gridPageHelper from "../../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../../ts/helpers/pageHelper"
import util from "../../../../ts/util"
import { TWijmoCellTemplateContext } from "../../../../type/wijmoComponents"
import { faFileAlt, faPlayCircle } from "@fortawesome/free-regular-svg-icons"
import MakePaymentExecModal from "./MakePaymentExecModal"
import EmptyTextHeader from "../../../../components/FlexGridWrapper/EmptyTextHeader"

type TOmitDisplay =
  | "支払担当コード"
  | "締日区分コード"
  | "支払書作成区分コード"
  | "支払額確認区分コード"
  | "傭車会社あり対象フラグ"
  | "表示順区分コード"

type T表示用検索条件 = Omit<TPaymentMakeListGetReq, TOmitDisplay> &
  Partial<{
    支払担当?: string
    締日区分?: string
    支払書作成区分?: string
  }>
/**
 * 支払処理
 * @returns
 */
const MakePayment = () => {
  const history = useHistory()
  const location = useLocation()

  const { zengetuStr: 前月 } = useSelector((state: RootState) => state.date)
  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "MakePayment_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        運送料: (item: TPaymentMakeListGetRes) =>
          new Decimal(item.運送料課税額 ?? 0)
            .plus(item.運送料非課税額 ?? 0)
            .toNumber(),
        付帯料: (item: TPaymentMakeListGetRes) =>
          new Decimal(item.付帯料課税額 ?? 0)
            .plus(item.付帯料非課税額 ?? 0)
            .toNumber(),
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TPaymentMakeListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TPaymentMakeListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new MakePaymentService().getList(currentSearchCondition)

      // 検索結果をstateにセット
      const gridCollectionView = createCollectionView(res.data, pageSize)

      if (isExecSime) {
        // 支払締め処理実行後の再検索時は元のページを表示する
        gridCollectionView.moveToPage(pageNumber)
      }
      setGridData({ data: gridCollectionView })
    } catch (error) {
      // dispatch(setAlerts(error))
      dispatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * 支払締め処理
   */
  const execSiharaiSime = async () => {
    // 支払締め処理の対象データを取得
    let 選択行番号: number[] = []
    let 対象支払先コード: string[] = []
    let isValid支払処理状態区分: boolean = false
    let errMessage: string[] = []

    selectedRows?.forEach((row) => {
      let item: TPaymentMakeListGetRes = row.dataItem

      選択行番号.push(row.index)
      対象支払先コード.push(item.支払先コード)

      switch (item.支払処理状態区分コード) {
        case "2": // 確定
          isValid支払処理状態区分 = true
          break
        case "3": // 送付済
          isValid支払処理状態区分 = true
          break
        default:
          break
      }
    })

    if (isValid支払処理状態区分) {
      errMessage.push(
        "・処理状態が「確定」または「送付済」の支払先は選択できません"
      )
    }

    if (errMessage.length > 0) {
      dispatch(setWarningAlerts(errMessage))
      return
    }

    const siharaiSimeCondition: TPaymentSiharaiSimePostReq = {
      支払年月: 支払年月 ?? undefined,
      支払先コード: 対象支払先コード?.slice() ?? undefined,
      支払先区分コード: "1" /* 1:傭車先 */,
    }
    const service = new MakePaymentService()

    try {
      let res: TApiResponse<TPaymentSiharaiSimeCheckListGetRes[]>
      res = await service.getCheckList(siharaiSimeCondition)
      if (res && res.data.length <= 0) {
        set選択行番号(選択行番号)
        set支払先コード(対象支払先コード)

        // 実行指示画面を表示
        setIsExecSime(false)
        setIsShow(true)
      } else {
        let msg: string[] = []
        msg.push("以下のデータの設定内容を確認してください")
        res.data.forEach((row) => {
          switch (row.区分コード) {
            case 0:
              msg.push(
                "・受注配車：" +
                  (row.受注伝票番号 ?? "") +
                  "-" +
                  (row.受注枝番 ?? "") +
                  "（" +
                  (row.メッセージ ?? "") +
                  "）"
              )
              break
            default:
              msg.push(
                "・支払先：" +
                  (row.支払先コード ?? "") +
                  "（" +
                  (row.メッセージ ?? "") +
                  "）"
              )
              break
          }
        })
        dispatch(setWarningAlerts(msg))
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  /**
   * 支払明細書印刷処理呼出し
   */
  const execPrintSiharaiMeisaisyo = async () => {
    let printExceptCount = 0
    let 対象支払先コード: string[] = []

    selectedRows?.forEach((row) => {
      let item: TPaymentMakeListGetRes = row.dataItem

      if (item.支払伝票番号 == null) {
        printExceptCount += 1
      }
      対象支払先コード.push(item.支払先コード)
    })

    if (printExceptCount > 0) {
      dispatch(setWarningAlerts(["支払データ未作成の支払先が選択されています"]))
      return
    }

    const siharaiSimeCondition: TPaymentSiharaiSimePostReq = {
      支払年月: 支払年月 ?? undefined,
      支払先コード: 対象支払先コード?.slice() ?? undefined,
      支払先区分コード: "1" /* 1:傭車先 */,
    }
    const service = new MakePaymentService()

    try {
      let simeRes: TApiResponse<TPaymentSiharaiSimeCheckListGetRes[]>
      simeRes = await service.getCheckList(siharaiSimeCondition)
      if (!simeRes || simeRes.data.length > 0) {
        let msg: string[] = []
        msg.push("以下のデータの設定内容を確認してください")
        simeRes.data.forEach((row) => {
          switch (row.区分コード) {
            case 0:
              msg.push(
                "・受注配車：" +
                  (row.受注伝票番号 ?? "") +
                  "-" +
                  (row.受注枝番 ?? "") +
                  "（" +
                  (row.メッセージ ?? "") +
                  "）"
              )
              break
            default:
              msg.push(
                "・支払先：" +
                  (row.支払先コード ?? "") +
                  "（" +
                  (row.メッセージ ?? "") +
                  "）"
              )
              break
          }
        })
        dispatch(setWarningAlerts(msg))
        return
      }

      let printRes: TApiResponse<TPaymentSiharaiMeisaisyoCheckListGetRes[]>
      printRes = await service.getSiharaiMeisaisyoCheckList(
        siharaiSimeCondition
      )
      if (!printRes || printRes.data.length > 0) {
        let msg: string[] = []
        msg.push(
          "以下の支払先は明細が修正されている可能性があります。再度、支払締め処理を実行してください"
        )
        printRes.data.forEach((row) => {
          msg.push("・" + (row.支払先名 ?? ""))
        })
        dispatch(setWarningAlerts(msg))
        return
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }

    selectedRows?.forEach((row) => {
      let item: TPaymentMakeListGetRes = row.dataItem

      // stateから印刷条件を生成
      let currentPrintCondition: TPaymentPrintSiharaiMeisaisyoReq =
        createPrintCondition(item)

      // 印刷処理を実行
      printSiharaiMeisaisyo(currentPrintCondition)
    })
  }

  /**
   * 支払明細書印刷処理
   * @param printCondition 印刷条件
   */
  const printSiharaiMeisaisyo = async (
    printCondition: TPaymentPrintSiharaiMeisaisyoReq
  ) => {
    setIsSearching(true) // 検索中状態に遷移

    try {
      const service = new MakePaymentService({ responseType: "blob" })
      const res = await service.printSiharaiMeisaisyo(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TPaymentMakeListGetReq = queryString.parse(location.search)
    set支払年月(query.支払年月)
    return query as TPaymentMakeListGetReq
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TPaymentMakeListGetReq => {
    return {
      支払年月: 支払年月 ?? "",
      支払先区分コード: "1" /* 1:傭車先 */,
    }
  }

  /**
   * 印刷条件オブジェクトを生成
   */
  const createPrintCondition = (
    item: TPaymentMakeListGetRes
  ): TPaymentPrintSiharaiMeisaisyoReq => {
    return {
      抽出条件_支払伝票番号: item.支払伝票番号 ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TPaymentMakeListGetReq
  ): T表示用検索条件 | undefined => {
    const disp年月 = dayjs(searchCondition.支払年月).format("YYYY/MM")
    return {
      支払年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set支払年月(前月)
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    // 行頭選択
    new wjcSelector.Selector(grid, {
      itemChecked: () => {
        setSelectedRows([...grid.rows.filter((r) => r.isSelected)])
      },
    })
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [支払年月, set支払年月] = useState<string | null | undefined>(前月)
  const [支払先コード, set支払先コード] = useState<string[] | null>()

  // 処理実行モーダル
  const [isShow, setIsShow] = useState<boolean>(false)
  const [isExecSime, setIsExecSime] = useState<boolean>(false)

  // 行選択
  const [selectedRows, setSelectedRows] = useState<wjGrid.Row[]>()
  const [選択行番号, set選択行番号] = useState<number[] | null>()

  //#endregion

  //#region [effect]

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `支払処理`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  useEffect(() => {
    if (isExecSime) {
      // 支払締め処理実行後の再検索
      search().finally(() => {
        if (flexGrid) {
          選択行番号?.forEach((selectedRowIndex) => {
            flexGrid.rows[selectedRowIndex].isSelected = true
          })
          setSelectedRows([...flexGrid.rows.filter((r) => r.isSelected)])
        }
        flexGrid?.refresh()
        dispatch(画面ロック解除())
      })
    }
    setIsExecSime(false)
  }, [isExecSime])
  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">支払処理</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-60rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body>
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <div className="search-condition-table">
                            <div className="search-condition-row">
                              <div className="w-8rem">
                                <MonthInput
                                  id="支払年月"
                                  placeholder="支払年月"
                                  isRequired={true}
                                  value={支払年月}
                                  defaultValue={前月}
                                  setValue={(v) => {
                                    set支払年月(v)
                                  }}></MonthInput>
                              </div>
                              <Button
                                type="submit"
                                className="ms-auto"
                                disabled={isSearching}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  e.preventDefault()
                                  search()
                                }}>
                                <FontAwesomeIcon icon={faSearch} />
                                検索
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={gridId}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  gridProperties={{
                    headersVisibility: wjGrid.HeadersVisibility.All,
                  }}
                  headerComponent={
                    <>
                      <Button
                        disabled={
                          isSearching ||
                          selectedRows == null ||
                          selectedRows.length <= 0
                        }
                        onClick={() => {
                          dispatch(clearAlert())
                          execSiharaiSime()
                        }}>
                        <FontAwesomeIcon icon={faPlayCircle} />
                        締処理実行
                      </Button>
                      <Button
                        className="btn-done"
                        style={{ marginLeft: "1.5rem" }}
                        disabled={
                          isSearching ||
                          selectedRows == null ||
                          selectedRows.length <= 0
                        }
                        onClick={(e) => {
                          dispatch(clearAlert())
                          e.preventDefault()
                          e.stopPropagation()
                          execPrintSiharaiMeisaisyo()
                        }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                        支払明細書印刷
                      </Button>
                    </>
                  }>
                  <wjrGrid.FlexGridColumn
                    allowDragging={false}
                    hasFilter={false}
                    header={"明細"}
                    allowSorting={false}
                    allowMerging={true}
                    align="center"
                    width={64}
                    selectable={false}
                    isReadOnly>
                    <EmptyTextHeader></EmptyTextHeader>

                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TPaymentMakeListGetRes>
                      ) => {
                        // 支払明細一覧
                        const url = util.getMenuPath(
                          請求_支払管理メニューコード.支払明細一覧
                        )[1]
                        return (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            onClick={() => {
                              dispatch(clearAlert())
                              if (context.item.支払合計ID == null) {
                                dispatch(
                                  setWarningAlerts([
                                    "支払締め処理が未実施の支払先です",
                                  ])
                                )
                                return
                              }
                              // 画面全体のスクロール位置の保存
                              gridPageHelper.savePageConditionData(
                                location.pathname
                              )
                              history.push(
                                url.replaceAll(
                                  ":id",
                                  context.item.支払合計ID.toString()
                                )
                              )
                            }}>
                            明細
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払先コード"
                    width={100}
                    header="支払先CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払先名"
                    width={250}
                    header="支払先名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払処理状態区分名称"
                    width={85}
                    header="処理状態"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払伝票番号"
                    width={120}
                    header="支払番号"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="運送料"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={100}
                    header="運送料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="付帯料"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={100}
                    header="付帯料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="高速料"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={100}
                    header="高速料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="消費税"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={96}
                    header="消費税"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払合計額"
                    cssClass="number-col"
                    dataType={wjCore.DataType.Number}
                    width={110}
                    header="支払合計額"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <MakePaymentExecModal
        isShow={isShow}
        setIsShow={setIsShow}
        isExecSime={isExecSime}
        setIsExecSime={setIsExecSime}
        size={"sm"}
        title={"支払締め処理実行"}
        支払年月={支払年月}
        支払先コード={支払先コード}></MakePaymentExecModal>
    </>
  )
}

export default MakePayment
